<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="'[User] ' + user.first_name + ' '+user.last_name+' - AMOS365'" />

            <h4 class="page-header mb-4">
                <span class="text-muted"><router-link to="/users">Users</router-link> / </span>{{ user.first_name }} {{ user.last_name }}

                <div class="float-right d-lg-inline-block d-none" v-if="canEdit">
                    <router-link :to="`/users/edit/${user.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
                    <router-link :to="`/users/reset-password/${user.id}`" class="btn btn-sm btn-default"><i class="fas fa-lock"></i> Reset Password</router-link>
                    <router-link :to="`/users/impersonate/${user.id}`" class="btn btn-sm btn-warning" v-if="$store.state.user.is_developer === 1"><i class="fas fa-user"></i> Impersonate</router-link>
                </div>
            </h4>

            <div class="d-lg-none d-block mb-3" v-if="canEdit">
                <router-link :to="`/users/edit/${user.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
                <router-link :to="`/users/reset-password/${user.id}`" class="btn btn-sm btn-default"><i class="fas fa-lock"></i> Reset Password</router-link>
                <router-link :to="`/users/impersonate/${user.id}`" class="btn btn-sm btn-warning" v-if="$store.state.user.is_developer === 1"><i class="fas fa-user"></i> Impersonate</router-link>
            </div>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card">
                        <div class="card-header">User Info</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">First Name:</div>
                                <div class="col-md-7">{{ user.first_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Last Name:</div>
                                <div class="col-md-7">{{ user.last_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Email:</div>
                                <div class="col-md-7">
                                    <a :href="`mailto:${user.email}`" title="Send Email">{{ user.email }}</a>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Timezone:</div>
                                <div class="col-md-7">{{ user.zone_slug }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Last Login:</div>
                                <div class="col-md-7">{{ user.last_login_at | moment('timezone', tz, "MM/DD/YYYY hh:mm a") }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Active:</div>
                                <div class="col-md-7">
                                    <label class="badge badge-success" v-if="user.is_active == 1">Active</label>
                                    <label class="badge badge-warning" v-else-if="user.is_active == 0">Inactive</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">

                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-m--x mt-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                    <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="tabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                        <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="pt-2">
                <div class="card" v-show="curTab === 'permissions'">
                    <div class="card-body">
                        <ul class="list-unstyled" v-for="perm in user.permissions">
                            <li><strong>{{ perm.name }}</strong>: {{ perm.description }}</li>
                        </ul>
                    </div>
                </div>
                <div v-show="curTab === 'login_history'">
                    <div class="card">
                        <div class="card-body">
                            <login-list :user_id="user.id" @loginCount="(count) => { this.loginCount = count; }" />
                        </div>
                    </div>
                </div>
                <div v-show="curTab === 'history'">
                    <div class="card">
                        <div class="card-body">
                            <history-list :record_id="user.id" record_type="User" @historyCount="(count) => { this.historyCount = count; }" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                curTab: 'permissions',
                loading: true,
                tz: this.$root.timezone,
                id: this.$route.params.id,
                user: {},
                historyCount: null,
                loginCount: null,
            }
        },

        computed: {
            canEdit(){
                return this.$root.hasPermission("users.manage");
            },

            tabs(){
                return [
                    {key: 'permissions', title: 'Permissions ('+this.user.permissions.length+')', icon: 'lock'},
                    {key: 'login_history', title: 'Logins ('+this.loginCount+')', icon: 'sign-in-alt'},
                    {key: 'history', title: 'History ('+this.historyCount+')', icon: 'clock'},
                ];
            },

            tabTitle(){
                //Loop
                for (var i = this.tabs.length - 1; i >= 0; i--)
                {
                    //Check tabl
                    if(this.tabs[i].key === this.curTab)
                    {
                        return '<i class="fa fa-'+this.tabs[i].icon+'"></i> ' + this.tabs[i].title;
                    }
                }

                //Send it
                return '';
            },
        },

        methods: {
            //Get the Customer
            getUser(){
                //Send it
                this.$http.get('/users/view/'+this.id)
                    .then(response => {
                        //Set the user
                        this.user = response.data.user;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            }
        },

        mounted() {
            //Get the user
            this.getUser();
        }
    }
</script>
